var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhyusillustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 637.47,
    height: 736.77,
    viewBox: "0 0 637.47 736.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M637.444,0c-92.622,0-211.64,26.448-286.8,80.555-.315.237-.657.473-.973.71C253.81,150.672,216.083,266.587,176.752,372.828,163.949,407.453,124.066,460.77,0,457.116V736.77c86.47,0,212.954-27.237,283.072-77.873,50.9-36.754,88.784-88.284,117.6-143.495,28.026-53.738,38.043-118.913,68.96-170.022,12.33-20.4,31.128-35.834,52.476-46.14,15.511-7.467,32.206-12.278,49.137-15.327,6.047-1.1,66.226-7.125,66.226-4.285V0Z",
    fill: "#932fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyusillustration);
export default __webpack_public_path__ + "static/media/whyusillustration.f949ed93bb2dc9a4572ae2984bcd77fd.svg";
export { ForwardRef as ReactComponent };